// extracted by mini-css-extract-plugin
export default {"ImageOverlay":"ImageOverlay_ImageOverlay__pBk0x","hatchimg":"ImageOverlay_hatchimg__l-S1-"};